/**
 * Request body for `PUT /api/users/me/billing` (MVP-10, tightened in MVP-40).
 * Mirrors the backend `UpdateBillingRequest` DTO — every field except
 * `departmentName` (HK-184) is required server-side. The form blocks submit
 * before the BE 400 fires.
 */
export interface IBillingUpdateRequest {
  fullName: string;
  companyName: string;
  departmentName?: string | null;
  billingStreet: string;
  billingZip: string;
  billingCity: string;
  billingCountryId: number;
  invoicingEmail: string;
}
